module.exports = __webpack_public_path__ + "static/media/Sketch7.132cfd4b.jpeg";